import { post } from '@/api/request';

// 点赞
export const cardLike = (parmas = { card_id: 1, comment_id: '内容' }) => post("like", parmas, undefined, { showGlobalMessage: false });
// 取消点赞
export const cardUnLike = (parmas = { card_id: 1, comment_id: '内容' }) => post("unLike", parmas, undefined, { showGlobalMessage: false });